import { useState, useEffect } from "react"; // اضافه کردن useEffect
import { useNavigate } from "react-router-dom";
import api from "./api";
import "../styles/login.css";
import logo from "../images/logo.png";
import { FaChevronLeft } from "react-icons/fa";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [timer, setTimer] = useState(120); // ۲ دقیقه = ۱۲۰ ثانیه
  const [isTimerActive, setIsTimerActive] = useState(false);
  const navigate = useNavigate();

  // تایمر
  useEffect(() => {
    let interval = null;
    if (isTimerActive && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsTimerActive(false);
      setError("مدت زمان اعتبار کد به پایان رسید. دوباره درخواست کنید.");
    }
    return () => clearInterval(interval);
  }, [isTimerActive, timer]);

  // فرمت کردن زمان به دقیقه:ثانیه
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  // درخواست مجدد کد
  const handleResendCode = async () => {
    setError("");
    setLoading(true);
    try {
      await api.post("manager/api/v1/password-reset-resend-code/", {
        phone_number: phone,
      });
      setTimer(120); // ریست تایمر
      setIsTimerActive(true);
      setError(""); // پاک کردن خطا
    } catch (err) {
      setError(err.response?.data?.message || "خطا در ارسال مجدد کد.");
    } finally {
      setLoading(false);
    }
  };

  const handleSendPhone = async (e) => {
    e.preventDefault();
    setError("");
    if (!phone.trim()) {
      setError("شماره تلفن را وارد کنید.");
      return;
    }
    setLoading(true);
    try {
      await api.post("manager/api/v1/password-reset-request-code/", {
        phone_number: phone,
      });
      setStep(2);
      setIsTimerActive(true); // شروع تایمر
      setTimer(120); // تنظیم تایمر به ۲ دقیقه
    } catch (err) {
      setError(err.response?.data?.message || "شماره تلفن نادرست است.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    setError("");

    if (!code.trim()) {
      setError("کد تایید را وارد کنید.");
      return;
    }

    setLoading(true);
    try {
      const res = await api.post("manager/api/v1/password-reset-verify-code/", {
        phone_number: phone,
        code: code,
      });

      if (res.data?.access && res.data?.refresh) {
        localStorage.setItem("accessToken", res.data.access);
        localStorage.setItem("refreshToken", res.data.refresh);
      }

      setIsTimerActive(false); // متوقف کردن تایمر
      setStep(3);

      setTimeout(() => {
        navigate("/");
      }, 5000);
    } catch (err) {
      setError(err.response?.data?.message || "کد تایید نادرست است.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <div className="login-body">
        <div className="wrapper">
          {step === 1 && (
            <form onSubmit={handleSendPhone}>
              <div className="login_box p-lg-5 p-4">
                <div className='logo-container d-flex justify-content-center'>
                  <img className='rounded-circle p-2' src={logo} width={60} height={60} alt="logo" />
                </div>
                <span className='fs-5 d-flex justify-content-center my-4'>مجموعه آموزشی پایتون تیک</span>
                <span className='green d-flex justify-content-center  mt-4'>ورود</span>
                <span className='complete-info my-2 d-flex justify-content-center'>برای ورود به پنل کاربری اطلاعات زیر را کامل کنید </span>

                {error && <div className="alert alert-danger">{error}</div>}
                <div className="input_box">
                  <input
                    type="text"
                    placeholder="شماره تلفن"
                    className="input-field"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
                <div className="input_box">
                  <button type="submit" className="input-submit" disabled={loading}>
                    {loading ? "در حال ارسال..." : "ارسال کد "}
                    <FaChevronLeft className='me-2' style={{ fontSize: "11px" }} />
                  </button>
                </div>
              </div>
            </form>
          )}

          {step === 2 && (
            <form onSubmit={handleVerifyCode}>
              <div className="login_box p-lg-5 p-4">
                <div className='logo-container d-flex justify-content-center'>
                  <img className='rounded-circle p-2' src={logo} width={60} height={60} alt="logo" />
                </div>
                <span className='fs-5 d-flex justify-content-center my-4'>مجموعه آموزشی پایتون تیک</span>
                <span className='green d-flex justify-content-center  mt-4'>ورود</span>
                <span className='complete-info my-2 d-flex justify-content-center'>
                  برای ورود به پنل کاربری اطلاعات زیر را کامل کنید
                </span>

                {error && <div className="alert alert-danger">{error}</div>}

                {/* نمایش شماره تلفن قبلی */}
                <div className="input_box">
                  <input
                    type="text"
                    value={phone}
                    readOnly
                    className="input-field bg-light"
                  />
                </div>

                <div className="input_box">
                  <input
                    type="text"
                    placeholder="کد تایید"
                    className="input-field"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                  />
                </div>

                {/* نمایش تایمر */}
                <div className="text-center my-2">
                  <span className="text-muted">
                    زمان باقی‌مانده: <strong className="" style={{color:"rgba(43, 167, 105, 1)"}}>{formatTime(timer)}</strong>
                  </span>
                </div>

                {/* دکمه ارسال مجدد کد */}
                <div className="text-center mb-3">
                  <button
                    type="button"
                    className="btn btn-link text-decoration-none"
                    onClick={handleResendCode}
                    disabled={isTimerActive || loading}
                  >
                    {loading ? "در حال ارسال..." : "ارسال مجدد کد"}
                  </button>
                </div>

                <div className="input_box">
                  <button type="submit" className="input-submit" disabled={loading}>
                    {loading ? "در حال بررسی..." : "تایید کد"}
                    <FaChevronLeft className='me-2' style={{ fontSize: "11px" }} />
                  </button>
                </div>
              </div>
            </form>
          )}

          {step === 3 && (
            <div className="login_box p-lg-5 p-4">
              <div className="alert alert-success text-center">
                ✅ رمز عبور جدید برای شما پیامک شد.
              </div>
              <div className="input_box">
                <button className="input-submit" onClick={() => navigate("/login")}>
                  بازگشت به صفحه ورود
                  <FaChevronLeft className='me-2' style={{ fontSize: "11px" }} />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;